import { memo, useEffect, useMemo } from 'react'
import Layout from 'components/core/Layout/Layout'
import Modal from 'components/interface/Modal/Modal'

/**
 * The `ModalSignedOut` handles the rendering of
 * the sign up modal
 *
 * @returns {React.ReactElement} the element
 */
function ModalSignedOut () {
  const title = useMemo(() => <h1>Signed Out</h1>, [])

  useEffect(() => {
    setTimeout(() => {
      window.location.reload()
    }, 700)
  }, [])

  return (
    <Modal.Container size="x-small">
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Layout.Body align="center">
          <p style={{ textAlign: 'center' }}>You are now signed out.</p>
        </Layout.Body>
      </Modal.Body>
      <Modal.Footer />
    </Modal.Container>
  )
}

// Memoize
export default memo(ModalSignedOut)
